export default {
    path: 'customer',
    component: () => import('../Customer.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách khách hàng',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo khách hàng',
            component: () => import('../table/createCus/Create.vue')
        },
        {
            path: 'cu/:id',
            name: 'Chỉnh sửa khách hàng',
            component: () => import('../table/updateCus/Update.vue')
        },
    ]
};